import angular from 'angular';
import module from '../module';
export default module.controller('SupportController', [
  '$scope',
  'AuthenticationService',
  '$sce',
  'enterpriseListService',
  function ($scope, AuthenticationService, $sce, enterpriseListService) {
    const CURRENT_USER = AuthenticationService.getCurrentUser();
    $scope.isMarketplace = false;
    $scope.pageTitle = 'Support';
    getEnterpriseDetails();

    const setSupportNumber = (function () {
      if (CURRENT_USER.user_type == 3) {
        $scope.support_number = CURRENT_USER.enterprise_info.support_phone;
        $scope.support_message = getSanitizeMessage(CURRENT_USER.enterprise_info.support_message || '');
       
      } else if (CURRENT_USER.user_type == 2) {
        $scope.isMarketplace = true;
        $scope.support_number = CURRENT_USER.market_place_info.support_phone;
      } else if (CURRENT_USER.user_type == 5) {
        $scope.support_number = CURRENT_USER.enterprise_info.support_phone;
      }
    })();

    function getEnterpriseDetails() {
      if (CURRENT_USER.user_type === 3) {
        enterpriseListService.getEnterprise(CURRENT_USER.enterprise_info.id).then(function (enterprise) {
          const enterpriseDetails = angular.copy(enterprise);
          if (enterpriseDetails && enterpriseDetails.details) {
            $scope.account_manager = {
              name: enterpriseDetails.details.account_manager_name || '',
              email: getSanitizeMessage(enterpriseDetails.details.account_manager_email || ''),
              phone: enterpriseDetails.details.account_manager_phone || '',
            };
          }
        });
      }
    }

    function getSanitizeMessage(message) {
      if (message) {
        const urlRegex = /((https?:\/\/)[^\s]+)|(www\.[^\s]+\.[^\s]+)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

        const replacedText =
        message.replace(
          urlRegex,
          function (match) {
            if (match.indexOf('@') > -1) {
              // Email address
              return '<a href="mailto:' + match + '">' + match + '</a>';
            } else if (match.indexOf('http') === 0) {
              // Full URL
              return '<a href="' + match + '" target="_blank">' + match + '</a>';
            } else {
              // www. URL
              return '<a href="http://' + match + '" target="_blank">' + match + '</a>';
            }
          }
        );
        return $sce.trustAsHtml(replacedText);
      }
      return '';
    }
  },

]);
